<template>
  <div  >
      <div>
    
      
    <navbar v-show="showNavbar" :idClub="$route.params.id" v-if="$store.getters.getUser!=null"/>
    
   
    
    <transition name="fade" mode="out-in"  :duration="{ enter: 300, leave: 300 }">
        <router-view/>
    </transition>
   
     <div v-if="isOnline" class="online" v-on:click="explainConnect=true">
       
     </div>
      <div v-if="isOffline" class="offline" v-on:click="explainConnect=true">
     </div>
     <div style="z-index=1000">
        <s-modal 
          :open="isRefresh"
          :close="false"
        >     
              Une version vient d'être déployée ... <br/>
              Nous vous conseillons de rafrachir votre page pour bénéificier des mises à jour...
              <br/><br/>
              <div style="display:inline-block;text-align:center">
                <s-button @onclick="update(false)" label="Plus tard ..." theme="is-danger"/>
                <br/><i>Il se peut que vous ayez des problèmes...</i>
              </div>
              <div style="display:inline-block;text-align:center;margin: 20px">
                <s-button @onclick="update(true)" label="Rachaichir" theme="is-success"/>
                <br/><i>Vous allez revenir à la page d'accueil</i>
              </div>
              
        </s-modal>
    </div>
     <div style="z-index=1000">
      <s-modal 
          :open="explainConnect"
          title=""
          @close="explainConnect=false"
          :close="true"    
      >
          <span v-if="isOffline" >
              <div class="offlineExplain">
              </div>
              <s-l id="deconnect">Vous êtes en mode déconnecté. Vous pouvez toujours utilisez l'application notamment gérer vos tournois en cours.<br/>
              Attention certaines fonctionnalités sont désactivées comme celles de créer un tournoi !<br/>
              <hr/>
              Si vous pensez que vous n'allez pas avoir de réseau pendant votre tournoi : pensez  à le créer avant !
              <hr/>
              Une fois que vous allez retrouvez la connexion, toutes vos données seront remis à jour dans la base de données !
              </s-l>
          </span>
          <span v-if="isOnline" >
              <div class="onlineExplain">
              </div>
              <div style="display:inline-block">
              <s-l id="connect">Vous êtes connecté.</s-l>
              </div>
          </span>
      </s-modal>
      <div style="z-index=2000">
      <s-modal
        :open="$store.getters.getEditor.state"
        title="Editeur"
        @close="closeEditor"
        :close="true"
      >
       <s-editor :label="$store.getters.getEditor" @close="closeEditor"/>
     </s-modal>
    </div>
     </div>
      </div>
      <div>
     <s-tuto/>
      </div>
  </div>
</template>
<style >
  :root {
    --backgound-color:#f4f5fa;
    --bluebg: #365789; /* rgb(41, 66, 148);*/
    --footerBg: #cad0d8;
  }
  html {
    background-color:  var(--backgound-color);
  }
  .g_notItems {
    font-size: 20px;
    color: black;
    padding-top: 80px;
    padding-left: 20px;
  }
   .g_headerDesktop {
        height: 102px;
        padding-top: 15px;
        padding-right: 20px;
        padding-left: 20px;
        top: 50px;
        width: 100%;
        z-index: 2;
        position: fixed;
        background-color:  var(--backgound-color);
        box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
        -webkit-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
        -moz-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
    }
  @media screen and (max-width: 420px) {  
   
    .g_menuDesktop {
      display: none;
    }
    .g_mobileOn {

    }
    .g_desktopOn {
        display: none;
    }
    .g_menuMobile {
        position: fixed;
        width: 100%;
        bottom: 0px;
        padding-top: 3px;
        padding-bottom: 27px;
        background-color: var(--footerBg);
        height: 105px;
        z-index: 2;
        box-shadow: 0px -3px 4px rgb(165, 165, 165);
        color: black;
    }
    .g_menuFooter {
        width: 100%;
        height: 100%;
        
    }
    .g_menuFooterMin {
        width: 100%;
        height: 100%;
        
    }
    .g_menuFooter tr td {
        width: 10%;
        height: 60%;
        text-align: center;
        vertical-align: bottom;
        font-size: 20px;
        font-weight: bolder;
        margin-bottom: 5px;
        vertical-align: top;
       
    }
     .g_menuFooterMin tr td {
        width: 20%;
        height: 60%;
        text-align: center;
        vertical-align: bottom;
        font-size: 13px;
        font-weight: bolder;
        margin-bottom: 5px;
        padding: 0px;
        vertical-align: top;
    }
    tr td.g_headerFooter {
        font-size: 15px;
        font-weight: bolder;
        color: black;
        height: 10px;
        padding-top: 5px;
        vertical-align: top;
    }
    .g_buttonFooter {
        margin-bottom: 5px;
    }
  }
  @media screen and (min-width: 420px) {  
    .g_desktopOn {
       
    }
    .g_menuDesktop {

    }
    .g_mobileOn {
      display: none;
    }
    .g_menuMobile {
       display: none;
    }
    
  }
 
</style>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.offline:hover {
  cursor: help;
}
 
.online:hover {
  cursor: help;
}
.offline {
      background-color: rgb(243, 46, 46);
      color: white;
      border-radius: 30px;
      background-image: url("./assets/notConnect.png");
      background-repeat: no-repeat;
       background-size: 70%;
      background-position: center;
      bottom: 5px;
      margin-right: 10px;
      height: 50px;
      width: 50px;
      position: fixed;
      right: 0;
      z-index: 1000;
      
  }
@media screen and (max-width: 420px) {
  .online {
      background-color: rgb(72, 179, 81);
      color: white;
      border-radius: 30px;
     
      background-image: url("./assets/connected.png");
      background-repeat: no-repeat;
      background-size: 80%;
      background-position: center;
      bottom: 5px;
      margin-right: 10px;
      height: 50px;
      width: 50px;
      position: fixed;
      right: 0;
      z-index: 1000;
  }
}
@media screen and (max-width: 420px) {
  .online {
     display: none;
  }
}
  
  .offlineExplain {
      background-color: rgb(243, 46, 46);
      color: white;
      border-radius: 30px;
      background-image: url("./assets/notConnect.png");
      background-repeat: no-repeat;
       background-size: 70%;
      background-position: center;
      bottom: 10px;
      margin-right: 10px;
      height: 50px;
      width: 50px;
      display: inline-block;
      right: 0;
      z-index: 1000;
      
  }
  .onlineExplain {
      background-color: rgb(72, 179, 81);
      color: white;
      border-radius: 30px;
      display: inline-block;
      background-image: url("./assets/connected.png");
      background-repeat: no-repeat;
      background-size: 80%;
      background-position: center;
      bottom: 10px;
      margin-right: 10px;
      height: 50px;
      width: 50px;
    
      right: 0;
      z-index: 1000;
  }
</style>
<script>
import "font-awesome/css/font-awesome.min.css";
import SEditor from "@/components/SEditor.vue"
import STuto from "@/components/STuto.vue"
import navbarTournoi from "@/views/tournoi/navbar.vue"
import firebase_api from "@/firebase/firebase_api"
export default {
  components: {
    SEditor,
    navbarTournoi,
    STuto
  },
  computed: {
    computedShowNavBar() {
        if (!this.showNavbar)
          return false;
        else {
          return setShowNavbar;
        }
    }
  },
  data() {
    return {
      explainConnect: false,
      showNavbar: false,
      setShowNavbar: true,
      club: {},
      home: true,
      registration:null,
      isRefresh: false,
      refreshing: false,
    }
  },
  computed: {
    userClub: {
      get() {
        return this.$store.getters.getUser
      }
    }
  },
  watch: {
    userClub(modifyUser, old) {
      var idClub = this.$route.params.id;
      var refresh = false;
      if (modifyUser!=null && old!=null) {
      if (typeof(idClub)!="undefined") {
        var newDemandes = modifyUser.demandes;
        var oldDemandes = old.demandes;
        if (typeof(newDemandes)!="undefined" && typeof(oldDemandes)!="undefined") {
            if (typeof(newDemandes[idClub])=="undefined" && typeof(oldDemandes[idClub])!="undefined")
              refresh = true;
            if (typeof(newDemandes[idClub])=="undefined" && typeof(oldDemandes[idClub])!="undefined")
                refresh = true;
            else if (typeof(newDemandes[idClub])!="undefined")
                if (newDemandes[idClub].status == false)
                  refresh = true;
        }
        var newClubs = modifyUser.clubs;
        var oldClubs = old.clubs;
        if (this.findClub(newClubs, idClub) && !this.findClub(oldClubs, idClub))
            refresh = true;
        if (!this.findClub(newClubs, idClub) && this.findClub(oldClubs, idClub))
            refresh = true;
      }
      if (refresh)
        location.reload();
      }
    },
    
    
    $route(to,from) {
      if (typeof(this.$route.meta.navbar) != "undefined")
        this.showNavbar = this.$route.meta.navbar;
      else
        this.showNavbar = false;
    },
    
    isOnline(val) {
        this.$store.dispatch("setonLastStatus", {
                    onLine: val
                }, ()=>{})
    }
  },
  methods: {
    findClub(clubs, idClub) {
        var index = clubs.findIndex(clubItem=>clubItem.idClub === idClub)
        return index != -1;
    },
    closeEditor() {
      this.$store.dispatch("editorOnOff", ()=>{

      })
    },
    appUpdateUI:function (e){
      this.registration = e.detail;
      this.isRefresh = true;
    },
    update(refresh){
     this.isRefresh = false;
     if (this.registration != null) {
        this.registration.waiting.postMessage({type:'SKIP_WAITING'});
     }
     if (refresh)
        window.location.reload(true)
   },

  },
  created() {
    document.addEventListener(
        'serviceWorkerUpdateEvent', this.appUpdateUI, { once: true }
    );
  },
  mounted() {
  
   const recaptcha = this.$recaptchaInstance
		if (recaptcha)
			recaptcha.hideBadge();
    this.$store.dispatch("setonLastStatus", {
                    onLine: this.isOnline
                }, ()=>{})
    if (typeof(this.$route.meta.navbar) != "undefined")
      this.showNavbar = this.$route.meta.navbar;
    else
      this.showNavbar = false;
  }
}
</script>


